export type ProductName = "Start" | "Plus" | "Pro" | "Contact";
export type AdvicePointer = "Start" | "Plus" | "Pro";

export type FeatureGroupKey =
  | "mobilityOptions"
  | "reports"
  | "integrations"
  | "policy"
  | "authentication"
  | "personalization"
  | "serviceAndProjectManagement";

export interface FeatureMetadata {
  labelKey: string;
  subLabelKey?: string;
  infoTextKey?: string;
}

export interface FeatureDetail extends FeatureMetadata {
  required: boolean;
}

export type Features = {
  [K in FeatureGroupKey]: Record<string, FeatureDetail>;
};

export type FeatureMetadataMap = {
  [K in FeatureGroupKey]: Record<string, FeatureMetadata>;
};

export type FeatureRequiredMap = {
  [K in FeatureGroupKey]?: Record<string, boolean>;
};

export interface Product {
  id: number;
  name: ProductName;
  priceInCents: number;
  pricedPerUnit: {
    user: number;
    period: string;
  };
  features: Features;
}

export interface additionalFee {
  included: boolean;
  priceInCents: number | null;
  unit: string;
}

export interface OnRequest {
  included: boolean;
  unit: string;
}

export const FEATURE_GROUPS: FeatureGroupKey[] = [
  "mobilityOptions",
  "reports",
  "integrations",
  "policy",
  "authentication",
  "personalization",
  "serviceAndProjectManagement",
];
